import { IcoRemove } from '@/utils/icons'
import cn from './index.module.css'
import Modal from '@common/Modal'
import TextField from '../../components/TextField/TextField'
import { useEffect, useState } from 'react'
import SecondaryButton from '../../components/SecondaryButton/SecondaryButton'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { useAddAlert } from '@/hooks/useAddAlert'
import { thematicsAPI } from '@/api'
import { fetchFolders } from '../../tabs/CourseSettingsTab/apiService'
import SelectField from '../../components/SelectField/SelectField'

const CreateSubFolderModal = ({
  isVisible,
  folderId,
  onDismiss = () => {},
  onCreate = (folder) => {},
}: {
  isVisible: boolean
  folderId?: number | null
  onDismiss: () => void
  onCreate: (folder: ISubFolder) => void
}) => {
  return (
    <Modal
      active={isVisible}
      setActive={onDismiss}
      // @ts-ignore
      className={cn.modalWrapper}
    >
      <CreateFolderModalBody
        folderId={folderId}
        onCreate={onCreate}
        onDismiss={onDismiss}
      />
    </Modal>
  )
}

const CreateFolderModalBody = ({
  folderId,
  onDismiss = () => {},
  onCreate = (folder) => {},
}: {
  folderId?: number | null
  onDismiss: () => void
  onCreate: (folder: ISubFolder) => void
}) => {
  const addAlert = useAddAlert()
  const [folders, setFolders] = useState<ISelect[]>([])
  const [selectedFolder, setSelectedFolder] = useState<number | null>(
    folderId ?? null,
  )
  const [name, setName] = useState('')
  const [isSaving, setIsSaving] = useState(false)
  const [error, setError] = useState<string[]>([])

  useEffect(() => {
    async function fetch() {
      let response = await fetchFolders()
      setFolders(
        response.map((item: IFolder) => ({
          label: item.name,
          value: item.id.toString(),
        })),
      )
    }

    fetch()
  }, [])

  const createFolder = () => {
    if (isSaving) return
    if (!selectedFolder) {
      setError(['folder'])
      return
    }
    if (!name) {
      setError(['name'])
      return
    }
    setIsSaving(true)

    thematicsAPI
      .addSubFolder({
        data: { parent_id: selectedFolder, name: name, view: 1 },
      })
      .then((res) => {
        if (res?.data?.status === 'success' || res?.data?.data?.id) {
          addAlert({ title: 'Подпапка создана!' })
          onCreate(res?.data?.data)
        } else
          addAlert({
            type: 'error',
            title:
              'Упс! Ошибка. Попробуйте ещё раз или обратитесь к администратору',
          })
      })
      .catch((error) => {
        addAlert({
          type: 'error',
          title:
            'Упс! Ошибка. Попробуйте ещё раз или обратитесь к администратору',
        })
      })
      .finally(() => setIsSaving(false))
  }

  return (
    <div className={cn.modalContainer}>
      <div className={cn.modalHeader}>
        <div className={cn.modalTitleContainer}>
          <span className={cn.modalHeaderTitle}>Создать подпапку</span>
        </div>
        <div className={cn.closeIcon} onClick={onDismiss}>
          <IcoRemove />
        </div>
      </div>
      <div className={cn.content}>
        <SelectField
          label="Основная папка"
          placeholder="Основная папка"
          value={selectedFolder?.toString()}
          onChange={(value) => setSelectedFolder(Number(value))}
          // @ts-ignore
          options={folders}
          className={cn.select}
          isInvalid={error.includes('folder')}
        />
        <TextField
          label="Введите название подпапки"
          placeholder='Новая папка'
          value={name}
          onChange={setName}
          className={cn.textField}
          isInvalid={error.includes('name')}
        />
      </div>
      <div className={cn.footer}>
        {isSaving && (
          <Spin
            indicator={
              <LoadingOutlined
                spin
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            }
          />
        )}
        <SecondaryButton onClick={createFolder} disabled={isSaving}>
          Создать
        </SecondaryButton>
      </div>
    </div>
  )
}

export default CreateSubFolderModal
